import logger from '../utils/rbata.logger';
import urlService from '../services/rbata.urlService';
import spinner from '../utils/rbata.spinner';

const addressHandling = {
    addressRequired:        $('#address-required'),
    deliveryAddressWrapper: $('#deliveryAddressWrapper'),
    addressForm:            undefined,
    formSubmitButton:       undefined,
    previousAddresses:      [],

    fetchAddress(data, hide, modified) {
        spinner.visibility(true);

        let request = $.ajax({
            url:     `${urlService.getBaseUrl()}checkout/multi/userdetails/fetch`,
            method:  'GET',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            data:    {
                'type':     data.selector,
                'id':       data.id,
                'modified': modified
            },
            cache:   false
        });

        request.done((response) => {
            // replace form content and init select menues
            let selectorToReplace = `#${data.selector}`;
            // we have to strip/remove the main html element(the form itself) from response
            $(selectorToReplace).replaceWith($(response).find(selectorToReplace));

            const $replacedContent = $(selectorToReplace);

            $replacedContent.find('.form-control--select').selectpicker({
                style:      'btn-select',
                dropupAuto: true
            });
            $(selectorToReplace).find('.form-control--select-title').selectpicker({
                noneSelectedText: '',
                style:            'btn-select',
                dropupAuto:       true
            });

            $replacedContent.find('.checkout__cancel-new-address')
                            .attr('data-target', selectorToReplace);

            if (hide) {
                logger.debug('sel hide:' + selectorToReplace);
                $replacedContent.addClass('d-none');
            } else {
                logger.debug('sel show:' + selectorToReplace);
                $replacedContent.removeClass('d-none');
            }
        });

        request.fail(function (x, e) {
            logger.debug('Cannot fetch address from backend');
        });

        request.always(() => {
            spinner.visibility(false);
        });
    },

    handleBillingAddressAsDeliveryAddressCheckBox(selected) {
        // show/hide the billing address section depending on the checkbox
        if (!selected) {
            this.deliveryAddressWrapper.addClass('d-none');
        } else {
            this.deliveryAddressWrapper.removeClass('d-none');
        }
        //do this on both toggle events
        addressHandling.resetDeliveryCheckbox();
    },

    handleAddressValidationMessage() {
        $('.checkout__radio-box').find('input').on('change', function () {
            $('.checkout__address-invalid').remove()
        });

        $('.checkout__address-data').on('change', '.form-control', function () {
            $(this).parents('.form-group').removeClass('is-invalid');
        });
    },

    toggleNewAddressButton(target, visible) {
        const $target          = $(target);
        const $targetFormField = $target.closest('.checkout__address-wrapper')
                                        .find('.js-checkout-address__add--wrapper');
        if (visible) {
            $target.hide();
            $targetFormField.show();
        } else {
            $target.show();
            $targetFormField.hide();
        }
    },

    resetDeliveryCheckbox() {
        const $billing = $('#billingAddressWrapper input[type=radio]:checked');
        if($billing.length === 0){
            //no checkboxes on the screen
            return;
        }

        const $oldDelivery = $('#deliveryAddressWrapper input[type=radio]:checked')
        $oldDelivery.closest('.checkout__radio-box').removeClass('checkout__radio-box--active')
        $oldDelivery.removeAttr('checked');

        const $newDelivery = $('#del_' + $billing.attr('id').substring(5));
        $newDelivery.closest('.checkout__radio-box').addClass('checkout__radio-box--active')
        $newDelivery.attr('checked', 'checked')

        // we have to replace the actual data in the hidden form to save the settings
        const data = $newDelivery.parent().data();
        addressHandling.fetchAddress(data, true, false);
    },

    setValue(target, value) {
        logger.debug('target: ' + target + ' value: ' + value);
        $(target).val(value);
    },

    cancelNewAddressAdd(event) {
        const $this        = $(event.currentTarget);
        const buttonTarget = $($this.data('target'))[0];
        addressHandling.toggleNewAddressButton(buttonTarget, true);
        addressHandling.restoreSaved($this.parents('.checkout__address-input-group'));
    },

    addNewAddress(evt) {
        const data = evt.currentTarget.dataset;
        addressHandling.fetchAddress(data, false, false);
        $('input[name="' + data.radioName + '"]').prop('checked', false);
        $(evt.currentTarget)
                .closest('.checkout__address-wrapper')
                .find('.checkout__radio-box--active')
                .removeClass('checkout__radio-box--active')
                .removeAttr('checked');
        addressHandling.toggleNewAddressButton(evt.currentTarget, false);
        addressHandling.setValue(data.newSelector, true);
        addressHandling.setValue(data.modifiedSelector, false);
    },

    deliveryAddressAsBillingAddress(evt) {
        addressHandling.handleBillingAddressAsDeliveryAddressCheckBox(evt.currentTarget.checked);

        let value = 'off';
        if (evt.currentTarget.checked) {
            value = 'on';
            addressHandling.setValue('#newAddress', false);
            addressHandling.setValue('#modified', false);
        }
        $(evt.currentTarget).next().val(value);
    },

    onSavedAddressChange(evt) {
        const $self = $(evt.currentTarget);
        $(".form-check-label").removeClass('checkout__radio-box--active');
        // handle the visual state of the white container
        $self.closest('.checkout__radio-box')
             .addClass('checkout__radio-box--active')
             .siblings()
             .removeClass('checkout__radio-box--active')
        // fetch data from edit button after radio buttons
        const data = $self.parent().data();
        // here we have to hide the address after fetching the data
        addressHandling.fetchAddress(data, true, true);
        addressHandling.setValue(data.newSelector, false);
        addressHandling.setValue(data.modifiedSelector, true);
        addressHandling.toggleNewAddressButton(evt.currentTarget, true);
        addressHandling.getSavedAddresses();
    },

    getSavedAddresses(init = false) {
        $('#userDetailsForm').find('.custom-control-radio-input:checked').each((i, el) => {
            if (init) {
                this.previousAddresses.push(el.id);
            } else {
                this.previousAddresses.forEach((savedAddress, index) => {
                    if (savedAddress.startsWith(el.dataset.prefix)) {
                        this.previousAddresses[index] = el.id;
                    }
                });
            }
        });
    },

    restoreSaved(parentElement) {
        // If user want to add address but then press cancel, restore previous address choice
        addressHandling.previousAddresses.forEach((el, i) => {
            const element = parentElement.find(`#${el}`);
            if (element.length) {
                element.prop('checked', true);
                element.siblings(".form-check-label").addClass('checkout__radio-box--active');
                return;
            }
        });
    },

    bindHandlers() {
        this.addressForm      = $('#userDetailsForm');
        this.formSubmitButton = $('#checkout__submit-button');
        this.addressForm.on('click', '.checkout__cancel-new-address', addressHandling.cancelNewAddressAdd);
        $('.js-checkout-address__add').on('click', addressHandling.addNewAddress);
        $('#delivery-address-as-billing-address').on('change', addressHandling.deliveryAddressAsBillingAddress);
        $('input[type=radio]').on('change', addressHandling.onSavedAddressChange);
        this.addressForm.on('submit', (e) => {
            spinner.visibility(true);
            // if ( window.history.replaceState ) {
            // Prevent going back to browser remembered form
            // window.history.replaceState( null, null, window.location.href );
            // }
        });
    }
};

$(() => {
    if ($('#checkout-address-page').length) {
        addressHandling.bindHandlers();
        addressHandling.handleAddressValidationMessage();
        addressHandling.getSavedAddresses(true);
    }
});
